import React from 'react'

function SingleUserCardMonthEarning({ month }) {
    return (
        <>
            <div>
                <img src={month?.mediaUrl} />
                <p>{month?.userId}</p>
            </div>
        </>
    )
}

export default SingleUserCardMonthEarning